import apiProtected, { api } from '@lib/api/apiClient';
import { server } from '@lib/api/http';
import { useMutation } from '@tanstack/react-query';

export const useLoginMutation = () => {
  return useMutation({
    mutationFn: async (input: { phoneNumber: string; password: string }) => {
      const { data } = await api.post(`${server}v1/auth/login`, {
        phoneNumber: input.phoneNumber,
        password: input.password,
        deviceToken: localStorage.getItem('deviceToken'),
        deviceType: 'web',
      });
      return data;
    },
  });
};

export const useResetPasswordMutation = () => {
  return useMutation({
    mutationFn: (input: {
      phoneNumber: string;
      password: string;
      confirmPassword: string;
      parentUserId: string | null;
    }) => api.patch(`${server}v1/auth/reset-password`, input),
  });
};

export const useSendOtpMutation = () => {
  return useMutation({
    mutationFn: (input: {
      phoneNumber: string;
      userRole?: string;
      capabilities?: string[];
      forgetPasswordOTP?: boolean;
    }) => api.post(`${server}v1/auth/send-otp`, input),
  });
};

export const useVerifyOtpMutation = () => {
  return useMutation({
    mutationFn: (input: { phoneNumber: string; otp: string }) =>
      api.post(`${server}v1/auth/verify-otp`, input),
  });
};

export const useLogoutMutation = () => {
  return useMutation({
    mutationFn: (input: { deviceType: string; userId?: string | number }) =>
      apiProtected.post(`${server}v1/auth/logout`, input),
  });
};

export const useAddInvitationMutation = () => {
  return useMutation({
    mutationFn: (invitationUrl: string) =>
      apiProtected.post(`${server}v1/invitations/add-invitation`, {
        invitationUrl,
      }),
  });
};
